<template>
	<div>
		<DashboardUser :profile="profile"></DashboardUser>
	</div>
</template>

<script>
import DashboardUser from '../components/DashboardUser.vue';
export default {
	name: 'SandPit',
	components: {
		DashboardUser,
	},
	data() {
		return {};
	},
	computed: {
		profile() {
			return this.$store.getters.profileGet;
		},
	},
	methods: {},
	mounted() {},
	created() {},
	destroyed() {},
	watch: {},
};
</script>

<style scoped></style>
